import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, intlShape } from "react-intl";
import logo from "../../../../../../assets/images/logo.svg";
import { ANNUAL } from "../payrollFrequencyTypes";
import { PremiumSimulatorDetails } from "./Details";
import { PremiumSimulatorDeductions } from "./Deductions";
import PremiumSimulatorParameters from "./PremiumSimulatorParameters";
import { PremiumSimulatorSummary } from "./Summary";

export class ResultContent extends React.Component {
  getPayPeriodTitleKeys(payrollFrequency) {
    if (payrollFrequency === ANNUAL.value) {
      return {
        summary: "clients.client.premiumSimulator.results.summary.annual",
        details: "clients.client.premiumSimulator.results.details.annual",
      };
    } else {
      return {
        summary: "clients.client.premiumSimulator.results.summary.payPeriod",
        details: "clients.client.premiumSimulator.results.details.payPeriod",
      };
    }
  }

  renderHeader() {
    const { client } = this.props;
    const { intl } = this.context;
    const provinceName = client.province.localizations[intl.locale].name;
    return (
      <div className="printSimulatorHeader">
        <span>
          <img src={logo} width="150" />
        </span>
        <div className="printSimulatorClient">
          <p>{client.name}</p>
          <p>{client.address}</p>
          <p>
            {client.city}, {provinceName}, {client.postalCode}
          </p>
        </div>
      </div>
    );
  }
  render() {
    const {
      memberClassName,
      memberDivisionName,
      parameters,
      results,
    } = this.props;
    const { summary, details, payrollDeductions } = results;
    const payPeriodTitleKeys = this.getPayPeriodTitleKeys(
      parameters.payrollFrequency
    );

    return (
      <div id="premiumSimulatorResults" className="premiumSimulatorResults">
        {this.renderHeader()}
        <PremiumSimulatorParameters
          member={results.memberCoverage.member}
          memberClassName={memberClassName}
          memberDivisionName={memberDivisionName}
          parameters={parameters}
        />
        <div>
          <h3>
            <FormattedMessage id="clients.client.premiumSimulator.results.results" />
          </h3>
          <div className="summaryGroup">
            <PremiumSimulatorSummary
              titleKey="clients.client.premiumSimulator.results.summary.monthly"
              {...summary.monthly}
            />
            <PremiumSimulatorSummary
              titleKey={payPeriodTitleKeys.summary}
              {...summary.payPeriod}
            />
          </div>
          <PremiumSimulatorDetails
            titleKey="clients.client.premiumSimulator.results.details.monthly"
            items={details.monthly}
            subtotal={summary.monthly.subtotal}
            total={summary.monthly.total}
            taxes={summary.monthly.taxes}
            memberClassName={memberClassName}
          />
          <PremiumSimulatorDetails
            titleKey={payPeriodTitleKeys.details}
            items={details.payPeriod}
            subtotal={summary.payPeriod.subtotal}
            taxes={summary.payPeriod.taxes}
            total={summary.payPeriod.total}
            memberClassName={memberClassName}
          />
          <PremiumSimulatorDeductions
            provinceCode={parameters.memberInfo.provinceCode}
            {...payrollDeductions}
          />
        </div>
      </div>
    );
  }
}

ResultContent.propTypes = {
  client: PropTypes.object,
  memberClassName: PropTypes.string,
  memberDivisionName: PropTypes.string,
  parameters: PropTypes.object,
  results: PropTypes.shape({
    details: PropTypes.object,
    payrollDeductions: PropTypes.object,
    summary: PropTypes.object,
    memberCoverage: PropTypes.object,
  }),
};

ResultContent.contextTypes = { intl: intlShape };



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/results/ResultContent.js